import ContentBox from '~/components/ContentBox';
import { usePlatformAccess } from '~/hooks/account';

import AddAcquisitionsPlan from './AddPlan/AddAcquisitionsPlan';
import AddCapturePlan from './AddPlan/AddCapturePlan';
import AddConversionsPlan from './AddPlan/AddConversionsPlan';
import AddOperationsPlan from './AddPlan/AddOperationsPlan';
import destinationGroups from './destinationsConfigurations';
import PlanDestinationGroup from './PlanDestinationGroup';
import useAvailableDestinations from './useAvailableDestinations';

export default function PlatformPlanDestinations({ segment }) {
  const enabledDestinations = useAvailableDestinations(segment.type);

  const {
    acquisitions,
    capture,
    conversions,
    operations,
  } = usePlatformAccess();

  return (
    <>
      {destinationGroups.map((group) => (
        <PlanDestinationGroup
          key={group.title}
          segment={segment}
          title={group.title}
          description={group.description}
          audiences={!!group.audiences}
          items={group.items}
          enabled={enabledDestinations}
        />
      ))}

      <div>
        {(acquisitions && capture && conversions && operations) || (
          <div className="flex flex-col pt-4 gap-4">
            <ContentBox.Title className=" text-gray-600">
              <h2 className="mb-1 text-base font-medium">
                Do more with Clearbit
              </h2>
              <p className="text-sm">
                Contact our success team to learn how we can help you achieve
                your goals by putting data to work.
              </p>
            </ContentBox.Title>

            <AddCapturePlan segment={segment} />
            <AddOperationsPlan segment={segment} />
            <AddAcquisitionsPlan segment={segment} />
            <AddConversionsPlan segment={segment} />
          </div>
        )}
      </div>
    </>
  );
}
